"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var Header_1 = require("./Header");
var SSO_1 = require("./SSO");
var Benefits_1 = require("./Benefits");
var translate_1 = require("utils/translate");
var ssoActions = require("@caddigital/sok-reducers/lib/actions/sso");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var MaintaenanceBanner_1 = require("components/MaintaenanceBanner");
var Types = require("types");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        translationStatus: state.translations.translations.status,
        list: state.sso.list,
        status: state.sso.status
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchSSOList: function () { return dispatch(ssoActions.fetchListRequest()); },
    fetchLanguage: function (language) {
        (0, translate_1.setLanguage)(language);
        dispatch((0, translations_1.fetchLanguageRequest)(language));
    }
}); };
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchSSOList();
    }
}), recompose_1.pure);
var component = function (props) { return (React.createElement("div", { className: 'sso-view' }, props.translationStatus === 'FETCHING' ? (React.createElement("div", { className: 'language-spinner' },
    React.createElement(sok_ui_1.LoadingSpinner, null))) : (React.createElement(React.Fragment, null,
    React.createElement(MaintaenanceBanner_1.default, null),
    React.createElement(Header_1.default, { fetchLanguage: props.fetchLanguage, selectedLanguage: props.selectedLanguage }),
    React.createElement(SSO_1.default, { status: props.status, list: props.list, selectedLanguage: props.selectedLanguage }),
    React.createElement(Benefits_1.default, { selectedLanguage: props.selectedLanguage }))))); };
exports.default = enhance(component);
